export default __webpack_public_path__ + "static/media/promo 3.82aa8073.PNG";